export function alphabeticalSort<T>(items: T[], key: keyof T): T[] {
  return [...items].sort((a, b) => {
    const first = a[key] as string
    const second = b[key] as string

    return first.localeCompare(second)
  })
}
